<template>
    <div class="campaign-box">
        <div class="campaign-option">
            <div class="campaign-option--title">Select Ad Product</div>
            <div class="campaign-option--subtitle">
                Select an ad product for your campaign.
            </div>
            <multiselect v-model="ad_product"
                         :options="adProducts"
                         label="label"
                         track-by="id"
                         :searchable="false"
                         :show-labels="false"
                         :allow-empty="false"
                         placeholder="Select">
            </multiselect>
            <div class="clearfix"></div>
            <label v-show="showErrors && !validation.ad_product" class="error" v-cloak>The Ad Product field is required.</label>
        </div>
    </div>
</template>

<script type="text/babel">
    import Multiselect from 'vue-multiselect'

    export default {
        props: [
            'value',
            'adProducts',
            'validation',
            'showErrors'
        ],

        data() {
            return {
                ad_product: this.value
            }
        },

        watch: {
            value(val) {
                this.ad_product = val;
            },

            ad_product(value) {
                this.$emit('input', value);
            }
        },

        components: {
            Multiselect
        }
    }
</script>
